export default "__VITE_ASSET__D8z8gZQ7__"